<template>
  <div class="vmp-rank-item--invite">
    <div class="order-cell">
      <RankNo
        :ranking="item && item.rank_no ? item.rank_no || 0 : 0"
        v-if="item && item.rank_no > 0"
      />
      <span v-else>--</span>
    </div>
    <div class="user-cell">
      <div class="avatar-wrap">
        <RankAvatar :ranking="item.rank_no" :src="item.img_url" />
        <p class="nickname truncate m-l-12">{{ item.invite_name || item.nick_name || '--' }}</p>
      </div>
    </div>

    <!-- 邀请多少人 -->
    <div class="invite-num-cell" :class="{ 'is-me': isMe }" @click="isMe && $emit('viewDetails')">
      <i18n path="nav.nav_1037">
        <span place="n" class="invite-num-color">
          {{ item.num }}
        </span>
      </i18n>
    </div>

    <!-- 去邀请, 邀请卡开关 -->
    <div v-if="isMe && showInvite && !isEmbed && !isCms" class="invite-go-cell">
      <vh-button type="primary" round class="invite-go-btn" @click="handleRowClick(item)">
        {{ $t('interact_tools.interact_tools_1121') }}
      </vh-button>
    </div>
  </div>
</template>
<script>
  import RankAvatar from './avatar.vue';
  import RankNo from './rank-no.vue';

  export default {
    name: 'VmpRankItemWatch',
    props: {
      item: {
        type: Object,
        default() {
          return {
            rank_no: 0,
            nick_name: '--',
            num: 0
          };
        }
      },
      isMe: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      // 是否是cms嵌入
      isCms() {
        return this.$domainStore.state.roomBaseServer.isCms == 1;
      },
      /**
       * 是否后台开启邀请卡功能
       */
      showInvite() {
        return this.$domainStore.state.roomBaseServer.inviteCard.status == 1;
      },
      // 是否为嵌入页
      isEmbed() {
        return this.$domainStore.state.roomBaseServer.embedObj.embed;
      }
    },
    components: {
      RankAvatar,
      RankNo
    },
    methods: {
      formatName(str) {
        if (str.length > 2) {
          return str.substr(0, 1) + ''.padEnd(str.length - 2, '*') + str.substr(str.length - 1, 1);
        } else {
          return str;
        }
      },
      handleRowClick(item) {
        this.$emit('doRowClick', item);
      }
    }
  };
</script>
<style lang="less">
  .vmp-rank-item--invite {
    padding: 0 24px;
    height: 54px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #262626;

    .order-cell {
      width: 25px;
      text-align: left;
      color: var(--theme-tab-content-rank-content-font);
    }
    .user-cell {
      margin-left: 2px;
      min-width: 106px;
      flex: 1;

      .nickname {
        color: var(--theme-tab-content-rank-content-font);
      }

      .truncate {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .m-l-12 {
        margin-left: 12px;
      }
    }

    .avatar-wrap {
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: center;
      align-content: stretch;

      min-width: 160px;
      .nickname {
        max-width: 100px;
      }
    }

    .avatar {
      width: 24px;
      height: 24px;
      border-radius: 50%;
    }

    .invite-num-cell {
      width: 120px;
      text-align: right;
      color: var(--theme-tab-content-rank-content-font);
      .invite-num-color {
        color: var(--theme-color-main);
      }
      &.is-me {
        cursor: pointer;
      }
    }
    .invite-go-cell {
      width: 120px;
      text-align: right;
      // background: olivedrab;

      .invite-go-btn {
        background: var(--theme-color-main);
        border-color: var(--theme-color-main);
        color: #fff;
        padding: 2px 8px;
      }
    }
  }
</style>
